import { httpClient } from '@/api/http-client'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
type ReadContractParams = {
  deal_key: string
}

type ReadContractResponse = {
  signature_request_key: string
  signature_type: string
}

const readContract = async (
  params: ReadContractParams,
): Promise<ReadContractResponse> => {
  const response = await httpClient(
    'accounting-dealer',
  ).get<ReadContractResponse>(`/v3/contract/${params.deal_key}/signature`)

  return response.data
}

export const useReadContract = (
  { deal_key }: ReadContractParams,
  options?: Partial<UseQueryOptions<ReadContractResponse>>,
) => {
  return useQuery({
    queryKey: ['contract', deal_key],
    queryFn: () => readContract({ deal_key }),
    staleTime: 0,
    ...options,
  })
}
